import * as React from "react";
import { I18nProvider } from "../i18n";
import { AssociationProvider, NotificationProvider, UserProvider } from "../contexts";

// Providers only — no UI. This runs as `wrapRootElement`, which Gatsby also applies around the Head
// component, so any element rendered here ends up inside <head> ("<div> is not a valid head
// element"). NotificationContainer therefore lives in `wrapPageElement` instead.
export const ContextWrapper = ({ children }: React.PropsWithChildren) => {
  return (
    <I18nProvider>
      <NotificationProvider>
        <UserProvider>
          <AssociationProvider>{children}</AssociationProvider>
        </UserProvider>
      </NotificationProvider>
    </I18nProvider>
  );
};

export default ContextWrapper;
